<template>
    <div class="flex float-left vertical-center">
        <span @click="showPopup">{{ this.params.value }}</span>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ColumnClickedAgGridComponent",
        data() {
            return {}
        },
        methods: {
            showPopup() {
                this.$vs.dialog({
                    color: this.colorAlert,
                    title: "Info",
                    text: this.params.value,
                    acceptText: "Copy to clipboard",
                    accept: this.copyToClipboard
                })
            },
            copyToClipboard() {
                if (!navigator.clipboard) {
                    this.fallbackCopyTextToClipboard(this.params.value);
                    return;
                }

                navigator.clipboard.writeText(this.params.value).then(function () {
                    console.log('Async: Copying to clipboard was successful!');
                }, function (err) {
                    console.error('Async: Could not copy text: ', err);
                });
            },
            fallbackCopyTextToClipboard(text) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    this.showNotifSuccess()
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    this.showNotifError()
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            },
            showNotifSuccess(){
                this.$vs.notify({
                    color:'success',
                    title:'Info',
                    position: "top-right",
                    text:'Copying to clipboard was successful!'
                })
            },
            showNotifError(){
                this.$vs.notify({
                    color:'danger',
                    title:'Info',
                    position: "top-right",
                    text:'Unable to copy!'
                })
            }
        },
        created() {

        }
    })
</script>

<style>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .vs-dialog-text {
        max-height: 300px;
        overflow: auto;
    }
</style>